<template>
  <div class="control-styling-information">
    <h6>Styling / Classes</h6>
    <div class="form-group">
      <label>Container Size Class</label>
      <select v-model="control.containerClass" class="form-control">
        <option v-for="(className, classID) in containerClasses" :key="classID" :value="className">
          {{classID}} ({{className}})
        </option>
      </select>
    </div>
    <div class="form-group">
      <label>Container Additional Classes</label>
      <input type="text" v-model="control.additionalContainerClass" class="form-control" />
    </div>
    <div class="form-group">
      <label>Control Field Additional Classes</label>
      <input type="text" v-model="control.additionalFieldClass" class="form-control" />
    </div>
    <div class="form-group">
      <label>Control-Label Additional Classes</label>
      <input type="text" v-model="control.additionalLabelClass" class="form-control" />
    </div>
  </div>
</template>

<script>
import {STYLE_INJECTION_MIXIN} from "../../../mixins/style-injection-mixin";

export default {
  name: "ControlStylingInformation",
  mixins: [STYLE_INJECTION_MIXIN],
  props: {
    control: { type: Object, required: true }
  },
  computed: {
    containerClasses() {
      return this.styles && this.styles.COLUMNS ? this.styles.COLUMNS : {}
    }
  }
}
</script>

<style scoped>
.control-styling-information h6 {
  margin-bottom: 12px;
  font-weight: 600;
  color: #374151;
}

.form-group {
  margin-bottom: 12px;
}

.form-group label {
  display: block;
  margin-bottom: 4px;
  font-size: 13px;
  font-weight: 500;
  color: #4b5563;
}

.form-control {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.form-control:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

select.form-control {
  cursor: pointer;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e");
  background-position: right 8px center;
  background-repeat: no-repeat;
  background-size: 20px;
  padding-right: 32px;
  appearance: none;
}
</style>
